<template>
  <div
    v-if="visibleJurisdictions.length"
    class="flsa-jurisdiction-submissions w-100"
  >
    <div
      class="flsa-jurisdiction-submissions-or-divider d-flex align-center ga-2 px-4 my-6"
      aria-hidden="true"
    >
      <div class="flsa-jurisdiction-submissions-or-line flex-grow-1" />
      <span class="text-caption text-textLight font-weight-medium">OR</span>
      <div class="flsa-jurisdiction-submissions-or-line flex-grow-1" />
    </div>

    <div class="text-h1 text-textDarkest px-8 py-4">
      Review Existing FLSA Submissions
    </div>

    <FlsaJurisdictionRow
      v-for="jurisdiction in visibleJurisdictions"
      :key="jurisdiction"
      :jurisdiction="jurisdiction"
      :submissions="groupedSubmissions.get(jurisdiction) ?? []"
      :default-expanded="jurisdiction === FEDERAL_JURISDICTION"
      @latest-click="handleSubmissionNavigate"
      @submission-click="handleSubmissionNavigate"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import FlsaJurisdictionRow from '@/components/jobProfiles/editor/FlsaJurisdictionRow.vue';
import { groupSubmissionsByJurisdiction } from '@/helpers/flsa';

const FEDERAL_JURISDICTION = 'federal';

const props = defineProps({
  submissions: {
    type: Array,
    default: () => [],
  },
});

const router = useRouter();

const groupedSubmissions = computed(() => groupSubmissionsByJurisdiction(props.submissions));

const visibleJurisdictions = computed(() => {
  const federalSubmissions = groupedSubmissions.value.get(FEDERAL_JURISDICTION) ?? [];

  if (!federalSubmissions.length) return [];

  return [FEDERAL_JURISDICTION];
});

const handleSubmissionNavigate = (submission) => {
  router.push({ name: 'flsa-form-view', params: { submissionUlid: submission.ulid } });
};
</script>

<style scoped lang="less">
.flsa-jurisdiction-submissions-or-line {
  border-top: 1px solid @stroke-default;
}
</style>
